import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration, ChartItem, registerables } from 'chart.js';
import { _DeepPartialObject } from 'chart.js/types/utils';

@Component({
  selector: 'fun-new-graphic',
  templateUrl: './new-graphic.component.html',
  styleUrls: ['./new-graphic.component.scss'],
})
export class NewGraphicComponent implements OnInit {

  @Input() public lastUpdates;
  @Input() public listOfYears;
  @Input() public startDate;
  @Input() public date;
  @Input() public filter;

  @Input() public data;
  @Input() public productionEstimated;
  @Input() public productionToday;

  @Input() public dataIncomes;
  @Input() public moneyToday;
  @Input() public moneyEstimated;

  @Input() public productionHistoric;
  @Input() public moneyHistoric;

  @Output() public clickYearPicker = new EventEmitter<any>();

  public context: CanvasRenderingContext2D;
  labelList = [];
  chart: any;
  ctx: any;

  public contextIncomes: CanvasRenderingContext2D;
  labelListIncomes = [];
  chartIncomes: any;
  ctxIncomes: any;

  public dataIndex = 0;
  public dataIndexDrill = 0;

  productionEstimateArray: any;
  productionArray: any;

  incomesEstimateArray: any;
  incomesArray: any;

  currentYear = '';
  currentMonth = 1;
  currentDay = '';
  listOfMonths = [
    { label: 'enero', value: 1 },
    { label: 'febrero', value: 2 },
    { label: 'marzo', value: 3 },
    { label: 'abril', value: 4 },
    { label: 'mayo', value: 5 },
    { label: 'junio', value: 6 },
    { label: 'julio', value: 7 },
    { label: 'agosto', value: 8 },
    { label: 'septiembre', value: 9 },
    { label: 'octubre', value: 10 },
    { label: 'noviembre', value: 11 },
    { label: 'diciembre', value: 12 }
  ];
  isLoading = false;

  constructor(public chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.productionEstimateArray = this.data.map(item => item.data_estimate);
    this.productionArray = this.data.map(item => item.data);
    this.labelList = this.data.map(item => item.label);

    this.incomesEstimateArray = this.dataIncomes.map(item => item.data_estimate);
    this.incomesArray = this.dataIncomes.map(item => item.data);
    this.labelListIncomes = this.dataIncomes.map(item => item.label);

    this.currentYear = this.parseCurrentYear(this.startDate);

    this.createGrapProduction();
    this.createGrapIncomes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && !changes['data'].firstChange) {
      this.filter = 'year';

      this.productionEstimateArray = this.data.map(item => item.data_estimate);
      this.productionArray = this.data.map(item => item.data);
      this.labelList = this.data.map(item => item.label);

      this.incomesEstimateArray = this.dataIncomes.map(item => item.data_estimate);
      this.incomesArray = this.dataIncomes.map(item => item.data);
      this.labelListIncomes = this.dataIncomes.map(item => item.label);

      this.currentYear = this.parseCurrentYear(this.date);

      this.chart.destroy();
      this.chartIncomes.destroy();

      this.createGrapProduction();
      this.createGrapIncomes();
    }
  }

  createGradient(startColor: string, endColor: string): CanvasGradient {
    const ctx = document.createElement('canvas').getContext('2d') as CanvasRenderingContext2D;
    const gradient = ctx.createLinearGradient(0, 0, 0, 180); // Modifica las dimensiones del gradiente
    gradient.addColorStop(0, startColor);
    gradient.addColorStop(1, endColor);
    return gradient;
  }

  createGrapProduction() {
    const gradient1 = this.createGradient('rgba(255, 205, 62, 0.3)', 'rgba(255, 255, 255, 0.3)'); // Gradiente para el segundo conjunto de datos
    const gradient2 = this.createGradient('rgba(255, 205, 62, 0.3)', 'rgba(255, 255, 255, 0.3)'); // Gradiente para el primer conjunto de datos
    const animation: _DeepPartialObject<any> = this.getAnimation();
    Chart.register(...registerables);
    const dataConfig = {
      labels: this.labelList,
      datasets: [
        {
          label: 'Real (kWh)',
          data: this.productionArray, //this.mockPoints,
          borderColor: '#FF6C3E', // Los naranjas #FF679B #FF5C2F (mejor) #FF6C3E
          backgroundColor: gradient1,
          borderWidth: 2,
          pointRadius: 0,
          fill: true,
          lineTension: 0.3
        },
        {
          label: 'Estimada (kWh)',
          data: this.productionEstimateArray, //this.mockPoints2,
          borderColor: '#FFCD3E', // Los amarillos de #FFCD3E a #FFF1BA ,
          backgroundColor: gradient2,
          borderWidth: 2,
          pointRadius: 0,
          fill: true,
          lineTension: 0.3
        },
      ]
    };
    const config: ChartConfiguration = {
      type: 'line',
      data: dataConfig,
      options: {
        animation,
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              pointStyle: 'circle',
              usePointStyle: true,
              padding: 25
            }
          },
          tooltip: {
            mode: 'index'
          },
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10,
          },
        },
        scales: {
          y: {
            display: true,
            grid: {
              display: false
            },
            title: {
              display: true,
              text: 'Producción (kWh)'
            }
          },
          x: {
            display: true,
            grid: {
              display: false
            }
          }
        },
        locale: 'de-DE',
        onClick: (event, elements) => {
          this.handleChartClick(event, elements);
        }
      }
    }
    const chartItem: ChartItem = document.getElementById('myChartProduction') as ChartItem;
    this.chart = new Chart(chartItem, config);
    this.chdRef.detectChanges();
  }

  createGrapIncomes() {
    const gradient1 = this.createGradient('rgba(255, 92, 47, 0.3)', 'rgba(255, 92, 47, 0.85)'); // Gradiente para el segundo conjunto de datos
    const gradient2 = this.createGradient('rgba(255, 205, 62, 0.3)', 'rgba(255, 255, 255, 0.3)'); // Gradiente para el primer conjunto de datos
    const animation: _DeepPartialObject<any> = this.getAnimationIncomes();
    Chart.register(...registerables);
    let config: ChartConfiguration = {
      type: 'bar',
      data: {
        labels: this.labelListIncomes,
        datasets: [
          {
            type: 'bar',
            label: 'Reales (€)',
            data: this.incomesArray, //this.mockPoints,
            borderColor: '#FF6C3E', // Los naranjas #FF679B #FF5C2F (mejor) #FF6C3E
            backgroundColor: gradient1,
            borderRadius: 18,
            borderWidth: 0,
            barPercentage: 1,
            categoryPercentage: 0.6,
            borderSkipped: false
          },
          {
            type: 'line',
            label: 'Estimados (€)',
            data: this.incomesEstimateArray, //this.mockPoints2,
            borderColor: '#FFCD3E', // Los amarillos de #FFCD3E a #FFF1BA ,
            backgroundColor: gradient2,
            borderWidth: 2,
            pointRadius: 0,
            fill: true,
          }
        ]
      },
      options: {
        animation,
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              pointStyle: 'circle',
              usePointStyle: true,
              padding: 25
            }
          },
          tooltip: {
            mode: 'index'
          },
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10,
          },
        },
        scales: {
          y: {
            display: true,
            grid: {
              display: false
            },
            title: {
              display: true,
              text: 'Ingresos (€)'
            }
          },
          x: {
            display: true,
            grid: {
              display: false
            }
          }
        },
        locale: 'de-DE',
        onClick: (event, elements) => {
          this.handleChartClick(event, elements);
        }
      }
    }

    config.data.datasets[1]['lineTension'] = 0.3;
    const chartItem: ChartItem = document.getElementById('myChartIncomes') as ChartItem;
    this.chartIncomes = new Chart(chartItem, config);
    this.chdRef.detectChanges();
  }

  handleChartClick(event, elements): void {
    if (elements.length > 0 && this.filter != 'day') {
      const dataIndexChart = elements[0].index;
      const label = this.chart.data.labels[dataIndexChart];

      let type = '';
      let newData = [];
      let newDataIncomes = [];

      if (label.length > 3) {
        // Gestionamos botones y label
        type = 'day';
        this.dataIndexDrill = dataIndexChart;
        newData = this.data[this.dataIndex].data_days[this.dataIndexDrill].data_hours; // Datos para el "drilldown"
        newDataIncomes = this.dataIncomes[this.dataIndex].data_days[this.dataIndexDrill].data_hours; // Datos para el "drilldown"
      } else {
        type = 'month';
        this.dataIndex = dataIndexChart;
        newData = this.data[this.dataIndex].data_days; // Datos para el "drilldown"
        newDataIncomes = this.dataIncomes[this.dataIndex].data_days; // Datos para el "drilldown"
      }

      this.updateChartData(newData, newDataIncomes, type, label);
      this.drillUp();
    }
  }

  drillUp() {
    const drillUp = document.getElementById('btnResetGraphic');
    drillUp.addEventListener('click', (evt) => {
      this.chart.destroy();
      this.chartIncomes.destroy();
      const dataChangeGraphic = {
        type: 'year',
        label: '',
        total: this.productionArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
        totalEstimate: this.productionEstimateArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
        totalIncomes: this.incomesArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
        totalEstimateIncomes: this.incomesEstimateArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      }
      this.changeDate(dataChangeGraphic);

      this.createGrapProduction();
      this.createGrapIncomes();
    });
  }

  changeDate(data) {
    const type = data.type;
    this.filter = type;
    switch (type) {
      case 'year': this.date = this.parseCurrentYear(this.startDate);
        this.currentYear = this.date;
        break;
      case 'month': this.date = (data.label !== undefined) ? `${this.parseLiteralMonth(data.label)} de ${this.parseCurrentYear(this.startDate)}` : `${this.parseCurrentMonth(this.startDate)} de ${this.parseCurrentYear(this.startDate)}`;
        this.currentMonth = this.parseCurrentMonthNumber(this.date);
        break;
      case 'day': this.date = (data.label !== undefined) ? `${this.parseLiteralDay(data.label)} de ${this.parseCurrentYear(this.startDate)}` : 'SD';
        break;
    }
    this.productionToday = data.total.toFixed(0);
    this.productionEstimated = data.totalEstimate.toFixed(0);
    this.moneyToday = (data.totalIncomes < 100) ? data.totalIncomes.toFixed(1) : data.totalIncomes.toFixed(0);
    this.moneyEstimated = (data.totalEstimateIncomes < 100) ? data.totalEstimateIncomes.toFixed(1) : data.totalEstimateIncomes.toFixed(0);

    this.chdRef.detectChanges();
  }

  parseLiteralDay(fecha: string): string {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    // Dividir la fecha en año, mes y día
    const [dia, mes] = fecha.split(' ');
    const literalMes = this.listOfMonths[months.indexOf(mes)].label;
    return `${dia} de ${literalMes}`;
  }

  parseLiteralMonth(mes: string): string {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const literalMes = this.listOfMonths[months.indexOf(mes)].label;
    return literalMes;
  }

  parseCurrentMonth(fecha: string): string {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    // Dividir la fecha en año, mes y día
    const [ano, mes, dia] = fecha.split('-');

    // Crear un nuevo objeto de fecha con los componentes extraídos
    const fechaObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    // Obtener los componentes de la nueva fecha
    const nuevoMes = fechaObj.getMonth(); // Nota: los meses comienzan desde 0

    // Formatear los componentes en el formato deseado
    const formatoDeseado = this.parseLiteralMonth(months[nuevoMes]);

    return formatoDeseado;
  }

  parseCurrentMonthNumber(fecha: string): number {
    const months = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    // Dividir la fecha en año, mes y día
    const [mes, ano] = fecha.split(' de ');

    // Obtener los componentes de la nueva fecha
    const nuevoMes = months.indexOf(mes) + 1; // Nota: los meses comienzan desde 0

    return nuevoMes;
  }

  parseCurrentYear(fecha: string): string {
    // Dividir la fecha en año, mes y día
    const [ano, mes, dia] = fecha.split('-');

    // Crear un nuevo objeto de fecha con los componentes extraídos
    const fechaObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    // Obtener los componentes de la nueva fecha
    const nuevoAno = fechaObj.getFullYear(); // Obtener solo los últimos dos dígitos del año

    // Formatear los componentes en el formato deseado
    const formatoDeseado = `${nuevoAno.toString()}`;

    return formatoDeseado;
  }

  getAnimation() {
    const totalDuration = 1000;
    const delayBetweenPoints = totalDuration / this.labelList.length;
    const previousY = (ctx) => ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y;
    return {
      x: {
        type: 'number',
        easing: 'linear',
        duration: delayBetweenPoints,
        from: NaN, // the point is initially skipped
        delay(ctx) {
          if (ctx.type !== 'data' || ctx.xStarted) {
            return 0;
          }
          ctx.xStarted = true;
          return ctx.index * delayBetweenPoints;
        }
      },
      y: {
        type: 'number',
        easing: 'linear',
        duration: delayBetweenPoints,
        from: previousY,
        delay(ctx) {
          if (ctx.type !== 'data' || ctx.yStarted) {
            return 0;
          }
          ctx.yStarted = true;
          return ctx.index * delayBetweenPoints;
        }
      }
    };
  }

  getAnimationIncomes() {
    const totalDuration = 1000;
    const delayBetweenPoints = totalDuration / this.labelList.length;
    const previousY = (ctxIncomes) => ctxIncomes.index === 0 ? ctxIncomes.chart.scales.y.getPixelForValue(100) : ctxIncomes.chart.getDatasetMeta(ctxIncomes.datasetIndex).data[ctxIncomes.index - 1].getProps(['y'], true).y;
    return {
      x: {
        type: 'number',
        easing: 'linear',
        duration: delayBetweenPoints,
        from: NaN, // the point is initially skipped
        delay(ctxIncomes) {
          if (ctxIncomes.type !== 'data' || ctxIncomes.xStarted) {
            return 0;
          }
          ctxIncomes.xStarted = true;
          return ctxIncomes.index * delayBetweenPoints;
        }
      },
      y: {
        type: 'number',
        easing: 'linear',
        duration: delayBetweenPoints,
        from: previousY,
        delay(ctxIncomes) {
          if (ctxIncomes.type !== 'data' || ctxIncomes.yStarted) {
            return 0;
          }
          ctxIncomes.yStarted = true;
          return ctxIncomes.index * delayBetweenPoints;
        }
      }
    };
  }

  onClickYearly() {
    this.isLoading = true;
    this.filter = 'year';

    const label = this.currentYear;
    const type = 'year';
    let newData = [];
    let newDataIncomes = [];

    newData = this.data; // Datos para la grafica
    newDataIncomes = this.dataIncomes; // Datos para la grafica
    this.updateChartData(newData, newDataIncomes, type, label);
  }

  onClickMonthly() {
    this.isLoading = true;
    this.filter = 'month';

    const label = "Ene";
    const type = 'month';
    let newData = [];
    let newDataIncomes = [];

    newData = this.data[0].data_days; // Datos para el "drilldown"
    newDataIncomes = this.dataIncomes[0].data_days; // Datos para el "drilldown"

    this.updateChartData(newData, newDataIncomes, type, label);
  }

  onChangeSelectYear(year) {
    this.isLoading = true;
    this.clickYearPicker.emit(year);
    setTimeout(() => this.chartLoaded(), 1500);
  }

  onChangeSelectMonth(month) {
    this.isLoading = true;
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const dataIndexChart = month - 1;
    const label = months[dataIndexChart];
    const type = 'month';
    let newData = [];
    let newDataIncomes = [];

    this.dataIndex = dataIndexChart;
    newData = this.data[this.dataIndex].data_days; // Datos para el "drilldown"
    newDataIncomes = this.dataIncomes[this.dataIndex].data_days; // Datos para el "drilldown"

    this.currentMonth = month;
    this.updateChartData(newData, newDataIncomes, type, label);
  }

  onChangeSelectDay() {
    this.isLoading = true;
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const dataIndexChart = this.currentMonth - 1;
    const initDay = 1;

    const label = `${initDay} ${months[dataIndexChart]}`;
    const type = 'day';
    let newData = [];
    let newDataIncomes = [];

    this.dataIndexDrill = 0;
    newData = this.data[dataIndexChart].data_days[this.dataIndexDrill].data_hours; // Datos para el "drilldown"
    newDataIncomes = this.dataIncomes[dataIndexChart].data_days[this.dataIndexDrill].data_hours; // Datos para el "drilldown"

    this.updateChartData(newData, newDataIncomes, type, label);
  }

  updateChartData(data, dataIncomes, type, label) {
    const productionEstimateArray = data.map(item => item.data_estimate);
    const productionArray = data.map(item => item.data);
    const labelsListProduction = data.map(item => item.label);
    const incomesEstimateArray = dataIncomes.map(item => item.data_estimate);
    const incomesArray = dataIncomes.map(item => item.data);
    const labelsListIncomes = dataIncomes.map(item => item.label);

    this.chart.data.labels = labelsListProduction;
    this.chart.data.datasets[0].data = productionArray;
    this.chart.data.datasets[1].data = productionEstimateArray;
    this.chartIncomes.data.labels = labelsListIncomes;
    this.chartIncomes.data.datasets[0].data = incomesArray;
    this.chartIncomes.data.datasets[1].data = incomesEstimateArray;

    const dataChangeGraphic = {
      type: type,
      label: label,
      total: productionArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
      totalEstimate: productionEstimateArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
      totalIncomes: incomesArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
      totalEstimateIncomes: incomesEstimateArray.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
    }
    this.changeDate(dataChangeGraphic);
    this.chart.update();
    this.chartIncomes.update();
    if (type != 'year') { this.drillUp(); } // Solo necesitamos el reset si el filtro no es anual
    setTimeout(() => this.chartLoaded(), 500);
  }

  chartLoaded() {
    this.isLoading = false;
  }
}
